import React from 'react';
import { useNavigate } from 'react-router-dom';

function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex justify-between items-center">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <img src="/logo-bkb.jpg" alt="Bank Kreiz Breizh" className="w-16 h-16 rounded-xl object-cover shadow-2xl border-2 border-yellow-400" />
          <div>
            <h1 className="text-lg font-bold">Banque Kreiz Breizh</h1>
            <p className="text-xs text-gray-300">Banque Centrale de Bretagne</p>
          </div>
        </div>
        <button 
          onClick={() => navigate('/')}
          className="px-6 py-2 bg-yellow-500 text-blue-900 rounded-lg font-semibold hover:bg-yellow-400 transition-colors"
        >
          Retour
        </button>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Mentions Légales</h1>

        <div className="space-y-8 text-gray-300">
          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Éditeur du site</h2>
            <p><strong>Raison sociale :</strong> Bank Kreiz Breizh - Banque Centrale de Bretagne</p>
            <p><strong>Forme juridique :</strong> Établissement Public à caractère financier</p>
            <p><strong>Capital social :</strong> 50.000.000 £B (Livres Bretonnes)</p>
            <p><strong>Siège social :</strong> 1 Place de la République, 29000 Quimper, Bretagne</p>
            <p><strong>Email :</strong> <a href="mailto:contact@bcb.bzh" className="text-yellow-400 hover:underline">contact@bcb.bzh</a></p>
            <p><strong>Téléphone :</strong> +33 (0)2 98 00 00 00</p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Directeur de la publication</h2>
            <p>Le directeur de la publication est le Gouverneur de la Banque Centrale de Bretagne.</p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Hébergement</h2>
            <p><strong>Hébergeur :</strong> Services Cloud Emergent</p>
            <p><strong>Adresse :</strong> Infrastructure cloud sécurisée</p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes) est la propriété 
              exclusive de Bank Kreiz Breizh, sauf mention contraire. Toute reproduction, représentation, 
              modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit 
              le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de 
              Bank Kreiz Breizh.
            </p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Protection des données personnelles</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un 
              droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
            </p>
            <p className="mt-4">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse : <a href="mailto:contact@bcb.bzh" className="text-yellow-400 hover:underline">contact@bcb.bzh</a>
            </p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Cookies</h2>
            <p>
              Ce site utilise des cookies nécessaires au bon fonctionnement du site et à l'amélioration de 
              votre expérience utilisateur. En poursuivant votre navigation sur ce site, vous acceptez 
              l'utilisation de cookies.
            </p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Responsabilité</h2>
            <p>
              Bank Kreiz Breizh s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
              sur ce site. Toutefois, Bank Kreiz Breizh ne peut garantir l'exactitude, la précision ou 
              l'exhaustivité des informations mises à disposition sur ce site.
            </p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Agrément et surveillance</h2>
            <p>
              Bank Kreiz Breizh est un établissement bancaire agréé et supervisé par l'Autorité Bancaire 
              de Bretagne (ABB). Numéro d'agrément : BKB-2024-001
            </p>
            <p className="mt-4">
              <strong>Fonds de Garantie des Dépôts :</strong> Les dépôts sont garantis jusqu'à 100.000 £B 
              par déposant par le Fonds de Garantie des Dépôts Bretons (FGDB).
            </p>
          </section>

          <section className="bg-blue-900 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Médiation bancaire</h2>
            <p>
              En cas de litige avec Bank Kreiz Breizh, vous pouvez saisir gratuitement le Médiateur Bancaire :
            </p>
            <p className="mt-2">
              <strong>Médiateur de la Banque Centrale de Bretagne</strong><br />
              BP 12345, 29000 Quimper, Bretagne<br />
              Email : <a href="mailto:mediateur@bcb.bzh" className="text-yellow-400 hover:underline">mediateur@bcb.bzh</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default MentionsLegales;
